import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled, { useTheme } from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';

import SponsorsCategory from '../sponsors-category';

const PageTitle = styled.span`
  display: block;
  color: ${(props) => props.theme.gray3};
`;

const PartnersLogos = () => {
  const {
    primaryColor,
    secondaryColor,
    standoutColor,
    gray4,
  } = useTheme();

  const { partners } = useStaticQuery(graphql`
    query PDVAllStrapiPartnersQuery {
      partners: allStrapiPartners(sort: { priority: ASC }) {
        nodes {
          id
          title
          category
          url
          text: childStrapiPartnersText {
            childMarkdownRemark {
              html
            }
          }
          logo {
            url
            localFile {
              childImageSharp {
                gatsbyImageData(
                  layout: FIXED
                  placeholder: BLURRED
                  width: 140
                )
              }
            }
          }
        }
      }
    }
  `);

  return (
    <Container small>
      <PageTitle>
        Deze partners helpen samen met Paul de Vries de online automotive beter te maken:
      </PageTitle>
      <SponsorsCategory
        title="Premium partners"
        color={secondaryColor}
        items={partners.nodes.filter(({ category }) => category === 'premium')}
      />
      <SponsorsCategory
        title="Podcast partners"
        color={primaryColor}
        items={partners.nodes.filter(({ category }) => category === 'podcast')}
      />
      <SponsorsCategory
        title="Event partners"
        color="#dd156a"
        items={partners.nodes.filter(({ category }) => category === 'event')}
      />
      <SponsorsCategory
        title="Business partners"
        color={gray4}
        items={partners.nodes.filter(({ category }) => category === 'business')}
      />
    </Container>
  );
};

export default PartnersLogos;
